import React from 'react';
import DisplayConfiguration from './DisplayConfiguration';
import { pickDataAttributes } from '../../../Util';

const styles = Object.freeze([{},{}]);

const Display240Flex = (props) => {
  const dataAttributes = pickDataAttributes(props, 'display-240-flex');
  
  return <DisplayConfiguration {...props} styles={styles} {...dataAttributes} className="display-240-flex" />;
}
export default Display240Flex;
